import { Maybe } from "@flockcover/flock-svc-core-types"
import { createRequest, platform } from "@shared/platform-api/requests"
import { createRequestHook } from "../../createRequestHook"
import { makeInitialScoreData } from "./utils"

type Input = Readonly<{ id: string }>
type Output = Maybe<number>

export const initialScores = createRequest<Input, Output>(async (input, getToken) => {
  const calculations = await platform(getToken).policies.rebateCalculationPeriods({
    id: input.id,
    telemetryDb: `telemetry`,
  })

  return makeInitialScoreData(calculations)
})

export const useGetInitialScores = createRequestHook(initialScores)
